export const CHART5_REQUEST = "CHART5_REQUEST";
export const CHART5_SUCCESS = "CHART5_SUCCESS";
export const CHART5_FAILURE = "CHART5_FAILURE";
